import React, { useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { updateDashboard } from '@api/dashboard';
import { useReport } from '../../hooks/useReport';
import DashboardEditor from '../Dashboard/DashboardEditor';

function ReportEditPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { report, loading } = useReport(id);
  const [saving, setSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = useCallback(
    async (reportData) => {
      setSaving(true);
      setSaveSuccess(false);
      setError(null);

      try {
        const response = await updateDashboard(id, reportData);

        if (response.status === 'success') {
          setSaveSuccess(true);
          navigate('/');
        } else {
          setError(`Failed to save report: ${response.message}`);
        }
      } catch (err) {
        setError(`Failed to save report: ${err.message}`);
      } finally {
        setSaving(false);
      }
    },
    [id, navigate],
  );

  const handleCancel = useCallback(() => {
    navigate('/');
  }, [navigate]);

  // Show loading while report is being fetched
  if (loading || !report) {
    return null; // Suspense fallback will show
  }

  return (
    <DashboardEditor
      dashboard={report}
      isCreating={false}
      saving={saving}
      saveSuccess={saveSuccess}
      error={error}
      onSave={handleSave}
      onCancel={handleCancel}
    />
  );
}

export default ReportEditPage;
